import { render, staticRenderFns } from "./brief.vue?vue&type=template&id=f01d4006&scoped=true"
import script from "./brief.vue?vue&type=script&lang=js"
export * from "./brief.vue?vue&type=script&lang=js"
import style0 from "./brief.vue?vue&type=style&index=0&id=f01d4006&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01d4006",
  null
  
)

export default component.exports